module.exports = __webpack_public_path__ + "img/top_phone_icon.15ca6068.png";